import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';

const companySizeOptions = {
    solo: { label: "Sole Trader", value: "soleTrader" },
    LimitedCompany: [
        { label: "1-3 Employees", value: "1-3 Employees" },
        { label: "3-10 Employees", value: "3-10 Employees" },
        { label: "10 - 20 Employees", value: "10 - 20 Employees" },
        { label: "20 + Employees", value: "20 + Employees" },
    ]
};

const CustomDropdown = ({ setFieldValue, value }) => {
    const [selectedValue, setSelectedValue] = useState('');

    // Sync selectedValue with `value` prop
    useEffect(() => {
        if (value) setSelectedValue(value);
    }, [value]);

    const handleSelect = (value) => {
        setSelectedValue(value);
        setFieldValue("companySize", value);
    };


    
    return (
        <DropdownButton title={selectedValue ? (selectedValue === "soleTrader" ? "Sole Trader":selectedValue)  : `Please select...`} variant="light"  className='size-company  business-company'  >
            <Dropdown.Item onClick={() => handleSelect(companySizeOptions.solo.value)}>
                {companySizeOptions.solo.label}
            </Dropdown.Item>

            <div className="dropdown-item with-submenu">
                Limited Company
                <div className="submenu">
                    {companySizeOptions.LimitedCompany.map((item, index) => (
                        <Dropdown.Item key={index} onClick={() => handleSelect(item.value)}>
                            {item.label}
                        </Dropdown.Item>
                    ))}
                </div>
            </div>
        </DropdownButton>
    );
};

export default CustomDropdown;
